import FaqSingle from "./components/FaqSingle"

import { useFaqStructured } from "./hooks"

import "./styles.scss"

const FaqStructured = ({ items = null, oneAtATime = true, ...props }) => {
  const { actives, handleClick } = useFaqStructured({
    items,
    oneAtATime,
  })

  return (
    <section
      itemscope=""
      data-testid="faq-structured"
      itemtype="https://schema.org/FAQPage"
    >
      {items?.map(
        ({ title, answerItem, answerVideoItem, onClick, index }, i) => (
          <FaqSingle
            title={title}
            answerItem={answerItem}
            answerVideoItem={answerVideoItem}
            index={index ?? i + 1}
            onClick={() => handleClick(onClick, index ?? i + 1)}
            open={actives.includes(index ?? i + 1)}
            key={index ?? i + 1}
            {...props}
          />
        ),
      )}
    </section>
  )
}

export default FaqStructured
